import { render } from "./PreviewArea.vue?vue&type=template&id=b1f8a624"
import script from "./PreviewArea.vue?vue&type=script&lang=js"
export * from "./PreviewArea.vue?vue&type=script&lang=js"

import "./PreviewArea.vue?vue&type=style&index=0&id=b1f8a624&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__